import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../app.reducers';
import { ImportRequest } from '../../shared/models';
import { Observable } from 'rxjs';
import { getImportRequest } from '../../admin-store/admin.selectors';
import {
  ClearAdminImportRequestAction,
  LoadAdminImportRequestAction, LoadAdminImportRequestDiffAction,
  ProcessAdminImportRequestAction
} from '../../admin-store';
import { ActivatedRoute, Params } from '@angular/router';
import { AdminDataImportRequestImportComponent } from '../../components/admin-data-import-request-import';
import { CommOperation } from '../../../../shared';
import { CommunicationStateComponent } from '../../../../shared';
import { AdminDataImportRequestExportDiffComponent } from '../../components/admin-data-import-request-export-diff';

@Component({
  templateUrl: './admin-import-request.component.html',
  styleUrls: ['./admin-import-request.component.scss'],
  standalone: false
})

export class AdminImportRequestComponent implements OnInit, OnDestroy {

  @ViewChild(AdminDataImportRequestExportDiffComponent) public exportDiff: AdminDataImportRequestExportDiffComponent;
  @ViewChild(AdminDataImportRequestImportComponent) public importComponent: AdminDataImportRequestImportComponent;
  @ViewChild('uploadState', { static: true }) public uploadCommunicationState: CommunicationStateComponent;

  importRequest$: Observable<ImportRequest>;
  importRequestId: string;

  constructor(private store: Store<AppState>,
    private route: ActivatedRoute) {
    this.importRequest$ = this.store.pipe(select(getImportRequest));
  }

  ngOnInit() {

    this.route.params.subscribe(
      (params: Params) => {
        this.importRequestId = params['id'];
        this.store.dispatch(new LoadAdminImportRequestAction(this.importRequestId));
      }
    );
  }

  ngOnDestroy() {
    this.store.dispatch(new ClearAdminImportRequestAction());
  }

  onExportDiff() {
    this.store.dispatch(new LoadAdminImportRequestDiffAction({ importRequestId: this.importRequestId, fiscalYear: null }));
  }

  onSubmit(fiscalYear: number) {
    const importRequestId = this.importRequestId;
    this.store.dispatch(new ProcessAdminImportRequestAction({ importRequestId, fiscalYear }));
  }

  onExportDiffYearSelected(fiscalYear: number) {
    this.store.dispatch(new LoadAdminImportRequestDiffAction({ importRequestId: this.importRequestId, fiscalYear: fiscalYear }));
  }

  onUploading() {
    // this.resetNotificationArea();
  }

  onUploaded(commOperation: CommOperation) {
    this.uploadCommunicationState.setCommOperation(commOperation);
  }
}
